import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CaretIcon from '../../../svg/CaretIcon';


export const GenericTable = ({
    data,
    columns,
    pageSize = 15,
    filterConfig = [],
    buttonConfig = [],
    searchableColumns = [],
    onRowClick = () => { }
}) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({});
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        setCurrentPage(1);
    }, [filters, searchTerm]);

    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({
            ...prev,
            [filterName]: value === 'All' ? null : value
        }));
    };
    let filteredData = []
    if(data.length > 0) {

        filteredData = data.filter(item => {
            // Handle time-based filtering
            if (filters.timeFilter) {
                const itemDate = new Date(`${item.scheduledDate} ${item.scheduledTime}`);
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
                switch (filters.timeFilter) {
                    case 'Past':
                        if (itemDate >= today) return false;
                        break;
                    case 'Current':
                        if (itemDate.toDateString() !== today.toDateString()) return false;
                        break;
                    case 'Upcoming':
                        if (itemDate <= today) return false;
                        break;
                    default:
                        break;
                }
            }
            // Handle status filtering
            if (filters.sessionStatus && item.sessionStatus !== filters.sessionStatus) {
                return false;
            }
    
            if (filters.paymentMethod && item.paymentMethod !== filters.paymentMethod) {
                return false
            }
            if (filters.paymentStatus && item.paymentStatus !== filters.paymentStatus) {
                return false
            }
            // Handle search
            if (searchTerm) {
                const searchMatch = searchableColumns.some(column =>
                    item[column]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
                );
                if (!searchMatch) return false;
            }
    
    
            return true;
        });
    }

    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const currentRecords = filteredData.slice(firstIndex, lastIndex);
    const totalPages = Math.ceil(filteredData.length / pageSize);
    const pageNumbers = [...Array(totalPages + 1).keys()].slice(1);

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="page-title flex-wrap mb-2">
                    <div className="input-group search-area mb-md-0 mb-3">
                        <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search here..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="d-flex gap-2">
                        {filterConfig.map(({ name, options, placeholder }) => (
                            <Dropdown key={name}>
                                <Dropdown.Toggle variant="outline-primary">
                                    {filters[name] || placeholder}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleFilterChange(name, 'All')}>
                                        All
                                    </Dropdown.Item>
                                    {options.map(option => (
                                        <Dropdown.Item
                                            key={option}
                                            onClick={() => handleFilterChange(name, option)}
                                        >
                                            {option}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        ))}
                        {buttonConfig.map(({ label, variant = 'primary', onClick }, index) => (
                            <button key={index} className={`btn btn-${variant}`} onClick={onClick}>
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                <div className="table-responsive full-data">
                    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table-responsive-sm table display dataTablesCard student-tab dataTable no-footer" id="example-student">
                            <thead>
                                <tr>
                                    {columns.map((column, index) => (
                                        <th key={index}>{column.header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentRecords.map((item, index) => (
                                    //
                                    <tr key={item.id || index} onClick={() => onRowClick(item)}>
                                        {columns.map((column, colIndex) => (
                                            <td key={colIndex}>
                                                {column.render ? column.render(item) : item[column.accessor]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="bg-white rounded shadow d-sm-flex text-center justify-content-between align-items-center mt-3">
                            <div className="dataTables_info">
                                Showing {firstIndex + 1} to {Math.min(lastIndex, filteredData.length)} of {filteredData.length} entries
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers mb-0 me-2">
                                <Link
                                    className={`previous ${currentPage === 1 ? 'disabled' : ''}`}
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (currentPage > 1) setCurrentPage(prev => prev - 1);
                                    }}
                                >
                                    <CaretIcon direction="right" width="25" height="25" />
                                </Link>
                                <span>
                                    {pageNumbers.map(number => (
                                        <Link
                                            key={number}
                                            className={`paginate_button ${currentPage === number ? 'current' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentPage(number);
                                            }}
                                            to="#"
                                        >
                                            {number}
                                        </Link>
                                    ))}
                                </span>
                                <Link
                                    className={`next ${currentPage === totalPages ? 'disabled' : ''}`}
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
                                    }}
                                >
                                    <CaretIcon direction="left" width="25" height="25" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};